import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { useStyles } from './styles';
import { useSignUpRedirect } from '~/hooks/useSignUpRedirect';

const AreYouNewBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  const { signUpRedirect } = useSignUpRedirect();
  return (
    <Box sx={styles.container}>
      <Box sx={styles.textBox}>
        <Typography variant="h3" sx={styles.title}>
          {t('landing.are_you_new')}
        </Typography>
        {/* Removed as we don't have text */}
        {/* <Typography sx={styles.text}>{t('landing.short_lorem_ipsum')}</Typography> */}
        <Button
          variant="outlined"
          size="large"
          color="primary"
          sx={styles.button}
          onClick={signUpRedirect}
        >
          {t('landing.create_accout')}
        </Button>
      </Box>
    </Box>
  );
};

export default AreYouNewBlock;
